<template>
  <TermsPage type="jobType" name="Types" :slug="$route.params.slug" />
</template>
